import React from "react";
import { FiInfo } from "react-icons/fi";
import Tooltip from "./Tooltip";

// Label + control + optional hint. Control chrome lives in control.js classes.
// `info` shows explanatory text in a tooltip on an info icon after the label.
export default function Field({
  label,
  children,
  required = false,
  note,
  info,
  hint,
  dimmed = false,
  className,
}) {
  const classes = ["rma-nc-field", dimmed ? "rma-nc-field--dimmed" : null, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <label className="rma-nc-field-label">
        {label}
        {required && <span className="rma-nc-field-required">*</span>}
        {note && <span className="rma-nc-field-note">{note}</span>}
        {info && (
          <Tooltip content={info} className="rma-nc-field-info">
            <button
              type="button"
              aria-label={`About ${label}`}
              className="rma-nc-field-info-button"
            >
              <FiInfo size={13} strokeWidth={2.25} />
            </button>
          </Tooltip>
        )}
      </label>
      {children}
      {hint && <p className="rma-nc-field-hint">{hint}</p>}
    </div>
  );
}
